<div style="width: 0">
  <igx-dialog #questionDialog>
    <div class="header neo-dialog-shell-header">
      <div class="neo-dialog-header">
        <div class="neo-dialog-header__leading">
          <div class="neo-dialog-header__icon" [hidden]="!questionIcon || questionIcon.length === 0">
            <igx-icon>{{ questionIcon }}</igx-icon>
          </div>
          <div class="neo-dialog-header__title">{{ questionTitulo | translate }}</div>
        </div>
        <div class="neo-dialog-header__actions">
          <button title="{{ 'BOTONES.CERRAR' | translate }}" igxIconButton="flat" class="neo-dialog-header__button" (buttonClick)="btnRespuesta(false)">
            <igx-icon>close</igx-icon>
          </button>
        </div>
      </div>
    </div>
    <div innerHTML="{{ questionMensaje | translate}}" class="tituloNotificaciones"></div>
    <div class="footer neo-dialog-footer">
      <div id="navBarFooter" class="neo-dialog-footer__actions">
        <button title="{{ 'BOTONES.ACEPTAR' | translate}}" igxButton="contained" (buttonClick)="btnRespuesta(true)" [igxFocus]="true">
          <igx-icon>check</igx-icon>
          <span>{{ 'BOTONES.ACEPTAR' | translate}}</span>
        </button>
        <button title="{{ 'BOTONES.CANCELAR' | translate}}" igxButton="flat" (buttonClick)="btnRespuesta(false)">
          <igx-icon>close</igx-icon>
          <span>{{ 'BOTONES.CANCELAR' | translate}}</span>
        </button>
      </div>
    </div>
  </igx-dialog>
</div>
